export class DateRangePicker {
  constructor({ elem, monthsToShow = 3, name = '' }) {
    this.container = document.getElementById(elem);
    this.monthsToShow = monthsToShow;
    this.startSelection = null;
    this.endSelection = null;
    this.name = name;

    this._createInputFields();
    this.renderCalendar();

    this.container.addEventListener('dragstart', (e) => e.preventDefault());
    this.container.addEventListener('mousedown', (e) => e.preventDefault());
  }

  _createInputFields() {
    const inputContainer = document.createElement('div');
    inputContainer.className = 'input-container';

    this.startInput = document.createElement('input');
    this.startInput.type = 'date';
    this.startInput.name = `${this.name}_startDate`;
    this.startInput.placeholder = 'Start Date';

    this.endInput = document.createElement('input');
    this.endInput.type = 'date';
    this.endInput.name = `${this.name}_endDate`;
    this.endInput.placeholder = 'End Date';

    // Скрытое поле для передачи скорректированного endDate (с offset)
    this.endHiddenInput = document.createElement('input');
    this.endHiddenInput.type = 'hidden';
    this.endHiddenInput.name = `${this.name}_endDate_adjusted`;

    inputContainer.appendChild(this.startInput);
    inputContainer.appendChild(this.endInput);
    inputContainer.appendChild(this.endHiddenInput);
    this.container.appendChild(inputContainer);
  }

  renderCalendar() {
    const monthContainer = document.createElement('div');
    monthContainer.className = 'month-container';

    const today = new Date();
    for (let i = -this.monthsToShow + 1; i < 1; i++) {
      const monthDate = new Date(today.getFullYear(), today.getMonth() + i, 1);
      monthContainer.appendChild(this.createMonthElement(monthDate));
    }
    this.container.appendChild(monthContainer);
  }

  createMonthElement(date) {
    const monthElement = document.createElement('div');
    monthElement.className = 'month';
    const monthName = date.toLocaleDateString('default', {
      month: 'long',
      year: 'numeric'
    });
    monthElement.innerHTML = `<h4>${monthName}</h4>`;
    const daysElement = document.createElement('div');
    daysElement.className = 'days';

    const startDay = (new Date(date.getFullYear(), date.getMonth(), 1).getDay() + 6) % 7;
    const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    for (let i = 0; i < startDay; i++) {
      daysElement.appendChild(document.createElement('div'));
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const dayElement = document.createElement('div');
      dayElement.className = 'day';
      dayElement.textContent = day;
      // Учтите: если day+1 используется для компенсации временной зоны – оставляем, иначе, возможно, стоит заменить на day
      dayElement.dataset.date = new Date(date.getFullYear(), date.getMonth(), day + 1).toISOString();

      dayElement.addEventListener('mousedown', (event) => this.handleDayMouseDown(event));
      dayElement.addEventListener('mouseover', (event) => this.handleDayMouseOver(event));
      dayElement.addEventListener('mouseup', () => this.handleDayMouseUp());
      daysElement.appendChild(dayElement);
    }
    monthElement.appendChild(daysElement);
    return monthElement;
  }

  handleDayMouseDown(event) {
    this.startSelection = new Date(event.target.dataset.date);
    this.endSelection = new Date(event.target.dataset.date);
    this.updateSelection();
  }

  handleDayMouseOver(event) {
    if (this.startSelection) {
      this.endSelection = new Date(event.target.dataset.date);
      this.updateSelection();
    }
  }

  handleDayMouseUp() {
    if (this.startSelection && this.endSelection) {
      // Корректируем порядок: если выбран обратный диапазон, меняем местами
      const [start, end] = this.startSelection <= this.endSelection ? [this.startSelection, this.endSelection] : [this.endSelection, this.startSelection];

      this.startInput.value = this.formatDate(start);
      this.endInput.value = this.formatDate(end);
      // Для скрытого поля подставляем дату с offset (23:59:59)
      this.endHiddenInput.value = this.formatDateTimeWithEndOffset(end);

      this.startSelection = null;
      // updateData() – метод, который, видимо, собирает данные для бекенда
      this.container.closest('fieldset').updateData();
    }
  }

  updateSelection() {
    document.querySelectorAll('.day').forEach((day) => {
      const dayDate = new Date(day.dataset.date);
      day.classList.remove('selected', 'range');

      const [start, end] = this.startSelection <= this.endSelection ? [this.startSelection, this.endSelection] : [this.endSelection, this.startSelection];

      if (start && end) {
        if (dayDate >= start && dayDate <= end) {
          day.classList.add(dayDate.getTime() === start.getTime() || dayDate.getTime() === end.getTime() ? 'selected' : 'range');
        }
      } else if (this.startSelection && dayDate.getTime() === this.startSelection.getTime()) {
        day.classList.add('selected');
      }
    });
  }

  formatDate(date) {
    return date.toISOString().substring(0, 10); // Формат "YYYY-MM-DD"
  }

  formatDateTimeWithEndOffset(date) {
    // Просто соединяем строковое представление даты с фиксированным временем конца дня
    return this.formatDate(date) + "T23:59:59.000Z";
  }
}
